import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  apiUrl = '';

  constructor(private http: HttpClient) {}

  load(): Promise<void> {
    return firstValueFrom(
      this.http.get<{ apiUrl: string }>('/config.json')
    ).then(config => {
      this.apiUrl = config.apiUrl;
    });
  }
}
